<template>
<div class="viewport">
    <div class="container">
        <a v-if="iswx" class="return" href="/"><img src="../assets/back.png" /><span>{{$t('bind.return')}}</span></a>
        <div class="no-auth-dialog" id="bind" v-if="isBind">
            <div class="auth-head">{{$t('bind.head')}}</div>
            <div class="auth-tip">{{$t('bind.tip')}}</div>
             <div class="input-div">
                 <input v-model="bind.account" type="text" name="account" class="account" :placeholder="$t('bind.user')"/>
             </div>
             <div class="input-div">
                 <input v-model="bind.password" type="password" name="password" class="password" :placeholder="$t('bind.password')"/>
             </div>
             <div class="btn-box">
                <a href="javascript:;" class="btn btn1" @click="bindSubmit">{{$t('bind.bind')}}</a>
             </div>
            <div class="no-auto-box">
                <div class="no-account-tip" @click="toReg">{{$t('bind.noAccount')}}</div>
            </div>
         </div>
         <div  class="no-auth-dialog" id="reg" v-else-if="!isBind">
            <div class="auth-head">{{$t('bind.regHead')}}</div>
            <div class="auth-tip">{{$t('bind.regTip')}}</div>
            <div class="input-div">
                <input v-model="reg.account" type="text" name="account" class="account" :placeholder="$t('bind.user')" />
            </div>
            <div class="input-div">
                <input v-model="reg.password" type="password" name="password" class="password" :placeholder="$t('bind.password')"/>
            </div>
            <div class="input-div">
                <input v-model="reg.confirm_password" type="password" name="confirm_password" class="confirm_password" :placeholder="$t('bind.confirm_password')" />
            </div>

            <template v-if="base_configs.reg_config && (base_configs.reg_config.phone || base_configs.reg_config.email)">
				<div class="input-div" v-if="base_configs.reg_config.email">
					<input type="text" v-model="reg.email" :placeholder="$t('bind.email')">
				</div>
				<div class="input-div" v-if="base_configs.reg_config.phone">
					<input type="text" v-model="reg.phone" :placeholder="$t('bind.phone')">
				</div>
				<div class="input-div">
					<input type="text" v-model="reg.code" @keyup.enter="regSubmit"  :placeholder="base_configs.reg_config.phone?$t('default.MessageAuthenticationCode'):$t('default.EmailAuthenticationCode')" class="code-input">
					<span class="code-btn">
						<wd-button 
							ref="reg-code-btn"
							@click.native="base_configs.reg_config.phone?sendMessageCode('reg'):sendEmailCode('reg')"
							type="info" 
							size="small" 
							:styles="{height:'44px',padding:'5px 15px'}"
							>{{$t('default.SendVerificationCode')}}</wd-button>
					</span>
				</div>
			</template>
            <div class="btn-box">
                <a href="javascript:;" class="btn btn-reg" @click="regSubmit">{{$t('bind.submit')}}</a>
            </div>
            <div class="no-account-tip" @click="toBind">{{$t('bind.hasAccount')}}</div>
        </div>
    </div>
    <img :src="clientWidth>750?bg1:bg2" alt="" class="loginbg">
</div>
</template>
<script>
import WdButton from '@/components/WdButton.vue';
const bg1 = require('../assets/login-bg1.jpg');
const bg2 = require('../assets/login-bg2.jpg');
export default {
    name: 'thirdbind',
    data() {
        return {
            bind: {
                account: '',
                password: ''
            },
            reg: {
                account: '',
                password: '',
                confirm_password:'',
                phone: '',
                email: '',
                code: ''
            },
            isBind: true,
            bindLoading: false,
            base_configs: {},
            clientWidth:document.body.clientWidth,
            bg1: require('../assets/login-bg1.jpg'),
            bg2: require('../assets/login-bg2.jpg')
        }
    },
    components:{
        'wd-button':WdButton,
    },
    computed:{
        iswx(){
            return !(window.opener || self != top)
        }
    },
    methods: {
        toBind() {
            this.isBind = true;
        },
        toReg() {
            this.isBind = false;
        },
        async bindSubmit() {
            if(!this.bind.account) return this.$alert(this.$t('bind.accountTip'));
            if(!this.bind.password) return this.$alert(this.$t('bind.passwordTip'));
            let data = {};
            if(this.regPhone(account)){
                data = {
                    type:2,
                    account:account,
                    password:password
                }
            }else if(this.isRegEmail(account)){
                data = {
                    type:4,
                    account:account,
                    password:password
                }
            }else{
                data = {
                    type:1,
                    account:account,
                    password:password
                }
            }
            if(this.bindLoading) return;
            this.bindLoading = true;
            let res = await this.$api.post('/thirdLogin/bind',data)
            if(res.code == 0){
                window.location.href = res.data.callback_url;
                this.bindLoading = false;
            }else{
                this.$alert(res.msg);
                this.bindLoading = false;
            }
        },
        async regSubmit() {
            if(!this.reg.account) return this.$alert(this.$t('bind.accountTip'));
            if(!this.reg.password) return this.$alert(this.$t('bind.passwordTip'));
            if(!this.passwordRex(this.reg.password)) return this.$alert(this.$t('bind.passwordErr'));
            if(this.reg.password != this.reg.confirm_password) return this.$alert(this.$t('bind.confirmTip'));
            let postData = {
                account:this.reg.account,
                password:this.reg.password,
                confirm_password:this.reg.confirm_password,
            }
            
            if(this.base_configs.reg_config.phone || this.base_configs.reg_config.email){
               if(this.base_configs.reg_config.phone) {
                    if(!this.reg.phone) return this.$alert(this.$t('bind.phoneTip'));
                    if(!this.regPhone(this.reg.phone)) return this.$alert(this.$t('bind.phoneErr'));
                    postData.phone = this.reg.phone;
               }
               if(this.base_configs.reg_config.email) {
                   if(!this.reg.phone) return this.$alert(this.$t('bind.emailTip'));
                    if(!this.regPhone(this.reg.email)) return this.$alert(this.$t('bind.emailErr'));
                    postData.email = this.reg.email;
               }
               if(!this.reg.code) return this.$alert(this.$t('bind.codeTip'));

            }

            if(this.bindLoading) return;
            this.bindLoading = true;
            let res = await this.$api.post('/thirdLogin/reg',postData)
            if(res.code == 0){
                window.location.href = res.data.callback_url;
                this.bindLoading = false;
            }else{
                if(res.code == 420036){
                    this.$alert(this.$t('bind.PhonwHasReged'));
                }else if(res.code == 420033){
                    this.$alert(this.$t('bind.AccountHasReged'));
                }else if(res.code == 420052){
                    this.$alert(this.$t('bind.VerificationCodeError'));
                }else if(res.code == 10002 || res.code == 10003){
                    this.$alert(this.$t('bind.EmailHasReged'));
                }else {
                    this.$alert(res.msg)
                }
                this.bindLoading = false;
            }
        },
        sendMessageCode(type){
            if(type == 'reg'){
                this.$refs['reg-code-btn'].sendMessageCode('reg',this.reg.phone);
            }
        },
        sendEmailCode(type){
            if(type == 'reg'){
                this.$refs['reg-code-btn'].sendEmailCode(type,this.reg.email);
            }
        },
        isRegEamil(email){
            return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(email);
        },
        regPhone(phone){
            return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(phone);
        },
        passwordRex(password){//至少包含数字和字母，可选部分特殊字符，6-16位
            return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z!@#$%^&*-_]{6,16}$/.test(password);
        },
        accountReg(account){//用户名正则 英文字母开头,不含中文，4-18位
            return /^[a-zA-Z][a-zA-Z0-9]{3,17}$/.test(account);
        }
    },
    async created() {
        this.from = this.$route.query.from || '';
        let {base_configs} = await this.$getAppBaseData(this.from);
	    this.base_configs = base_configs;
    }
}
</script>
<style scoped>
.viewport{
    width: 100%;
    height: 100%;
    background: #191818;
    position: relative;
}
.container{
    width: 100%;
    height: 100%;
    position:absolute;
    z-index: 2;  
    top: 0;
    left: 0;
}
.input-box{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.btn-box{
    width: 100%;
    margin-bottom: 10px;
}
.btn-box .btn{
    width: 100%;
    font-size: 16px;
    border-radius: 5px;
    background: #ce292c;
    color: #fff;
    text-align: center;
    height: 42px;
    line-height: 42px;
    display: inline-block;
    text-decoration: none;
} 

.no-auth-dialog{
    background: transparent;
    width: 280px;
    height: 100%;
    margin: 0 auto;
    padding-top: 70px;
    box-sizing: border-box;
}
.no-auth-dialog .auth-head{
    font-size: 25px;
    color: #fff;
    margin-top: 0px;
    margin-bottom: 10px;
}
.no-auth-dialog .auth-tip{
    font-size: 14px;
    line-height: 20px;
    color: #acabab;
    margin-top: 0px;
    margin-bottom: 20px;
}
.loginbg{
    width: 100%;
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    margin-bottom: 0;
}
.no-auth-dialog .input-div{
    width: 100%;
    display: flex;
    position: relative;
    background-color: #403f3f;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 8px 15px;
    margin-bottom: 10px;
}
.no-auth-dialog .input-div .iconfont{
    color: #999999;
    font-size: 22px;
    margin-right: 10px;
    line-height: 27px
}
.no-auth-dialog .input-div input{
    background-color: transparent;
    border:none;
    outline: none;
    width: 100%;
    color: #999;
    height: 26px;
    font-size: 14px
}
.no-auth-dialog .input-div input:focus{
    border: none;
}
.no-auth-dialog .or{
    width: 100%;
    color: #bababa;
    font-size: 16px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
}
.input-div input:-webkit-autofill {
    -webkit-text-fill-color: #fff !important;
    transition: background-color 5000s ease-in-out 0s;
}
.no-account-tip{
    font-size: 14px;
    line-height: 20px;
    color: #acabab;
    width: 100%;
    text-align: center;
    cursor: pointer;
}
.auto-account-tip{
    font-size: 14px;
    line-height: 20px;
    color: #acabab;
    cursor: pointer;
    margin-left: 65px;
}
.code-btn{
    font-size: 14px;
    border-radius: 5px;
    background: #ce292c;
    color: #fff;
    text-align: center;
    height: 42px;
    line-height: 42px;
    display: inline-block;
    text-decoration: none;
    padding: 0px 10px;
}
.return {
    height: 32px;
    cursor: pointer;
    position: absolute;
    left: 20px;
    top: 10px;
}
.return img{
    width: 32px;
    height: 32px;
    display: inline-block;
    vertical-align: middle;
}
.return span{
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    font-size: 12px;
    margin-left: 5px;
}
</style>